export const thematicPagesList = getters => {
  return getters.thematicPagesList
}
